var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef } from 'react';
import withDesign from '../../../hocs/withDesign';
import { SROnlyDescription } from '../../../theme/accessibility';
import icons from './icons';
import { StyledDiv, StyledIcon, StyledImage } from './styled';
var IconComponent = forwardRef(function (_a, ref) {
    var src = _a.src, as = _a.as, props = __rest(_a, ["src", "as"]);
    var IconSvg = icons[src];
    if (as === 'img') {
        return (_jsx(StyledImage, __assign({ src: IconSvg || src, ref: ref, alt: "derative" }, props)));
    }
    if (as === 'mask') {
        return (_jsx(StyledDiv, __assign({ src: IconSvg || src, ref: ref, alt: "derative" }, props)));
    }
    var srIconDescription = props.title || props.alt;
    return (_jsxs(_Fragment, { children: [_jsx(StyledIcon, __assign({ ref: ref }, props, { src: IconSvg || src })), srIconDescription && _jsx(SROnlyDescription, { children: srIconDescription })] }));
});
IconComponent.defaultProps = {
    size: 'stretch',
};
export * from './Icon.types';
export var Icon = withDesign(IconComponent);
Icon.icons = icons;
Icon.displayName = 'Icon';
